module.exports = __webpack_public_path__ + "static/media/14.bbf5f6d1.png";